export default __webpack_public_path__ + "static/media/september2024-3.f8a67dee.jpg";